export class ApiError extends Error {
  constructor(
    message: string,
    public status: number,
    public fields: Record<string, string> = {},
  ) {
    super(message);
  }
}
export async function api<T>(
  path: string,
  method = "GET",
  body?: unknown,
): Promise<T> {
  let response: Response;
  try {
    response = await fetch(`/api${path}`, {
      method,
      headers:
        body !== undefined ? { "Content-Type": "application/json" } : undefined,
      body: body !== undefined ? JSON.stringify(body) : undefined,
      credentials: "same-origin",
      redirect: "follow",
    });
  } catch {
    throw new ApiError(
      "You’re offline. Your draft is still on this device. Reconnect and try again.",
      0,
    );
  }
  if (!response.headers.get("content-type")?.includes("application/json"))
    throw new ApiError("Your sign-in expired. Reload to sign in again.", 401);
  const data = (await response.json()) as T & {
    error?: string;
    fields?: Record<string, string>;
  };
  if (!response.ok)
    throw new ApiError(
      data.error || "Please try again.",
      response.status,
      data.fields,
    );
  return data;
}
export function errorMessage(e: unknown) {
  return e instanceof Error ? e.message : "Please try again.";
}
